<div class="wrapper">
  <div class="row">
    <div class="col-sm-12 mb-2">
      <h1 class="pageTitle">{{pageTitle}}</h1>
      <!-- <app-notifications [notification]="'booking_details_page_notification_banner_child'"></app-notifications> -->
      <hr>
    </div>

    <div class="col-sm-12 col-md-5 col-lg-4 mt-4">
      <div class="card bb-panel">
        <ul class="menu-naviagtion" style="margin-bottom: 0px !important">
          <li *ngFor="let option of accountLinks" [class.selected]="option === selectedOption"
            (click)="onSelect(option)">
            <span>{{option}}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-sm-12 col-md-7 col-lg-8 mt-4">
      <app-my-account *ngIf="selectedOption === 'Account'"></app-my-account>
      <app-change-password *ngIf="selectedOption === 'Change password'"></app-change-password>
      <app-upcoming-bookings *ngIf="selectedOption === 'Upcoming bookings'"></app-upcoming-bookings>
      <app-past-bookings *ngIf="selectedOption === 'Past bookings'"></app-past-bookings>
    </div>
  </div>
  <br>
</div>